document.addEventListener('DOMContentLoaded', function () {
  initHeroSlider();
  rotateAnnouncements();
  stickHeaderOnScroll();
  initRelatedProducts();
});

function initHeroSlider() {
  const slider = document.querySelector('[data-hero-slider]');
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll('.hero-slide'));
  let index = 0;

  if (slides.length < 2) return;

  setInterval(function () {
    slides[index].classList.remove('active');
    index = (index + 1) % slides.length;
    slides[index].classList.add('active');
  }, 7000);
}

function rotateAnnouncements() {
  const container = document.querySelector('.announcement-carousel');
  if (!container) return;

  const items = Array.from(container.querySelectorAll('.announcement-item'));
  if (items.length < 2) return;

  let index = 0;
  setInterval(function () {
    index = (index + 1) % items.length;
    container.style.transform = `translateX(-${index * 100}%)`;
  }, 6000);
}

function stickHeaderOnScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', function () {
    if (window.scrollY > 24) {
      header.classList.add('header-scrolled');
    } else {
      header.classList.remove('header-scrolled');
    }
  });
}

function initRelatedProducts() {
  const container = document.querySelector('[data-related-products]');
  if (!container) return;

  const productId = container.dataset.productId;
  if (!productId) return;

  fetch(`/recommendations/products?product_id=${productId}&limit=4`)
    .then((response) => response.json())
    .then((data) => {
      if (!data || !data.products) return;
      container.innerHTML = data.products
        .slice(0, 4)
        .map((product) => {
          const image = product.featured_image || {};
          const imageUrl = image.src ? `${image.src}?width=480` : '';
          const alt = image.alt || `${product.title} collectible image`;
          return `
            <article class="related-card">
              <a href="${product.url}">
                <img src="${imageUrl}" alt="${alt}" loading="lazy" width="480" height="600">
                <div class="related-card-content">
                  <h3>${product.title}</h3>
                  <p>Explore ${product.title} accessories</p>
                </div>
              </a>
            </article>
          `;
        })
        .join('');
    })
    .catch(() => {
      const fallback = container.querySelector('.related-loading');
      if (fallback) fallback.textContent = 'Browse related collectibles in the shop.';
    });
}
